//
//
//
//
//
//
//

import { faFileAlt } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'ResumeLink',
  props: {
    resume: {
      type: Object,
      required: true
    }
  },
  computed: {
    docIcon () {
      return faFileAlt
    }
  },
  methods: {
    handleResumeOpen () {
      const url = `${process.env.bucketURL}/${this.resume.File?.fileName}`
      window.open(url)
    }
  }
}
